module.exports = __webpack_public_path__ + "img/19f.1a2388d5.png";